/**
 * Loading placeholder shaped like the table it replaces.
 *
 * 8loop's list pages use this rather than a spinner: the row height and column
 * count are already known, so the page does not jump when the data lands.
 */

import { Skeleton } from "@/components/ui/skeleton";

export function TableSkeleton({
  columnCount = 6,
  rowCount = 8,
}: {
  columnCount?: number;
  rowCount?: number;
}) {
  return (
    <div className="w-full" aria-busy="true" aria-label="Loading">
      <div className="flex h-8 items-center gap-4 border-b border-border px-2">
        {Array.from({ length: columnCount }).map((_, i) => (
          <Skeleton key={i} className="h-3 flex-1" />
        ))}
      </div>
      {Array.from({ length: rowCount }).map((_, row) => (
        <div key={row} className="flex h-10 items-center gap-4 border-b border-border px-2">
          {Array.from({ length: columnCount }).map((_, col) => (
            <Skeleton
              key={col}
              className="h-3 flex-1"
              // Staggered widths so it reads as content rather than a loading bar.
              style={{ maxWidth: `${[90, 70, 100, 60, 80, 75, 65, 85][(row + col) % 8]}%` }}
            />
          ))}
        </div>
      ))}
    </div>
  );
}
